import * as Api from '../api/api';
import * as Models from '../model/models';

declare var angular: any;
declare var google: any;

module SearchMapApp {
    "use strict";
    declare var lat: number;
    declare var lng: number;
    declare var zoom: number;
    declare var map: any;
    class MainCtrl {
        apiClient: Api.SearchApi;

        shopSearchThrottle: any;
        latE: number;
        lngN: number;
        latW: number;
        lngS: number;
        shopRows: Models.ShopCsvRow[];
       // map: google.maps.Map;
        selectedShop: Models.ShopCsvRow;
        oldMaker: any;
        test: string;

        constructor(private $scope: ng.IScope, private $http: ng.IHttpService) {
            var urlSplit = location.href.split('/');
            var apiBaseUrl = urlSplit[0] + "//" + urlSplit[2];


            this.apiClient = new Api.SearchApi($http, null, apiBaseUrl);
            //alert("b");

            //this.map = new google.maps.Map(document.getElementById('map'), {
            //    //center: <any>{ // 地図の中心を指定
            //    //    lat: lat, // 緯度
            //    //    lng: lng // 経度
            //    //},
            //    zoom: zoom
            //});
          //  this.shopSearchThrottle = _.throttle(this.search, 0.3);

          /*  google.maps.event.addListener(this.map, 'bounds_changed', ()=> {
                $("#addressList").val(
                    "北東:" + this.map.getBounds().getNorthEast().lat() + "," + this.map.getBounds().getNorthEast().lng() + "\r\n" +
                    "南西:" + this.map.getBounds().getSouthWest().lat() + "," + this.map.getBounds().getSouthWest().lng()
                );

                var bounds = this.map.getBounds();
                var ne = bounds.getNorthEast();
                var sw = bounds.getSouthWest();
                this.latE = ne.lat();
                this.lngN = ne.lng();
                this.latW = sw.lat();
                this.lngS = sw.lng();
                this.shopSearchThrottle();
            });*/
            this.apiClient.searchSearchShopAll().then(
                c => {
                    this.shopRows = c.data;

                    _(this.shopRows)
                        .each((c) => {
                            var marker = new google.maps.Marker({
                                position: <any>{
                                    lat: (<any>c).緯度,
                                    lng: (<any>c).経度
                                },
                                title: c.nameJA,
                                icon: {
                                    url: 'https://www.quraz.com/assets/img/common/marker_off.png', //アイコンのURL
                                    scaledSize: new google.maps.Size(53, 55) //サイズ
                                }
                            });
                            

                            (<any>marker).addListener("click", () => {
                                //;
                                console.log(marker);
                                marker.setIcon(<any>{
                                    url: "https://www.quraz.com/assets/img/common/marker_on.png",
                                    scaledSize: new google.maps.Size(53, 55) //サイズ
                                });

                                if (this.oldMaker != null)
                                {
                                    this.oldMaker.setIcon(<any>{
                                        url: "https://www.quraz.com/assets/img/common/marker_off.png",
                                        scaledSize: new google.maps.Size(53, 55) //サイズ
                                    });
                                }
                                this.oldMaker = marker;
                                this.selectedShop = c;
                                console.log(c);                                
                                this.$scope.$apply();
                            });

                            marker.setMap(map);
                            
                        });
                });

        }

        //search()
        //{
        //    this.apiClient.searchSearchShopByNSEW(
        //        this.latE,
        //        this.lngN,
        //        this.latW,
        //        this.lngS
        //    ).then(c => {
        //        this.shopRows = c.data;

        //        _(this.shopRows)
        //            .each((c) => {
        //                var image = 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png';
        //                var marker = new google.maps.Marker({
        //                    position: new google.maps.LatLng(c.緯度,c.経度 ),
        //                    title: "Hello World!",
        //                    icon: image,
        //                  //  url: 'http://www.nihonbashi-tokyo.jp/'
        //                });
        //                marker.setMap(this.map);
        //            });
        //    });
        //}

    }
angular.module("SearchMapApp", [])
    .controller("MainCtrl", <any>MainCtrl);

}
